import Sentry, { featureTags } from '@/services/sentry'

const DefaultLoader = {
  name: 'XmasTreeLoaderFallback',
  render: (h) => h('aha-loader'),
}

export const XmasTreeLoaderAsync = () => ({
  component: import(/* webpackChunkName: "xmas-tree-loader" */ './XmasTreeLoader.vue').catch((err) => {
    Sentry.captureException(err, {
      tags: featureTags({ featureFlag: 'kill-switch-xmas-decoration', featureName: 'xmas-tree-loader', taskId: 'THEM-123' }),
    })
    throw err
  }),
  loading: DefaultLoader,
  delay: 0,
  error: DefaultLoader,
})
